import { defineStore } from "pinia";

export enum AlertType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}

interface AlertModel {
  message: string;
  title?: string;
  visible: boolean;
  icon: string;
  type: AlertType;
  autoClose: boolean;
  autoCloseTimeout?: number;
  top: boolean;
}

const model: AlertModel = {
  message: "",
  title: "",
  visible: false,
  icon: "mdi-information",
  type: AlertType.Info,
  autoClose: true,
  autoCloseTimeout: 4000,
  top: false,
};

interface AlertParams {
  message?: string;
  title?: string;
  icon?: string;
  type?: AlertType;
  visible?: boolean;
  autoClose?: boolean;
  autoCloseTimeout?: number;
  top?: boolean;
}

export const useAlert = defineStore("alert", {
  state: (): AlertModel => ({ ...model }),
  actions: {
    setCurrent(params: AlertModel) {
      this.message = params.message || "";
      this.title = params.title || "";
      this.icon = params.icon || "mdi-information";
      this.type = params.type || AlertType.Info;
      this.visible = params.visible ?? false;
      this.autoClose = params.autoClose ?? true;
    },
    fire(params: AlertParams) {
      this.message = params.message || "";
      this.title = params.title || "";
      this.icon = params.icon || "mdi-information";
      this.type = params.type || AlertType.Info;
      this.visible = true;
      this.top = params.top ?? false;
      if (this.autoClose) {
        setTimeout(
          () => {
            this.reset();
          },
          params.autoCloseTimeout || this.autoCloseTimeout || 4000
        );
      }
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    reset() {
      this.setCurrent(model);
    },
  },
  getters: {
    // Add any getters here if needed
  },
});
